import React from 'react';
import {
  SolutionPremiumContent,
  SolutionSubPageLayout,
  getSolutionSubpage,
} from '../features/solutions';

export const SmartHospitality: React.FC = () => {
  const config = getSolutionSubpage('smart-hospitality');
  return (
    <SolutionSubPageLayout config={config}>
      <SolutionPremiumContent config={config} />
    </SolutionSubPageLayout>
  );
};
